import { createIcon } from '../../createIcon';
import { withIcon } from '../../withIcon';
import { LogInSvg } from './LogIn';

export const LogInIcon = createIcon('logIn', LogInSvg);
/**
 * @deprecated используйте LogInIcon
 */
export const withLogInIcon = withIcon('logIn', LogInSvg);
